import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "广告位设置列表", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_button, {
        style: {"margin-left":"auto"},
        type: "primary",
        onClick: _ctx.onAddAdpConfig
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_el_table, {
      data: _ctx.adpConfigList,
      style: {"min-height":"500px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "adpKey",
          label: "adpKey"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "广告位名字"
        }),
        _createVNode(_component_el_table_column, {
          prop: "adpid",
          label: "adpid"
        }),
        _createVNode(_component_el_table_column, {
          prop: "showRatio",
          label: "显示概率"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _withModifiers(($event: any) => (_ctx.onEditAdpConfig(scope.row)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _withModifiers(($event: any) => (_ctx.onDelAdpConfig(scope.row.hid)), ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      "current-page": _ctx.pagination.page,
      "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.page) = $event)),
      "page-count": _ctx.pagination.pageCount
    }, null, 8, ["current-page", "page-count"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDlg,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDlg) = $event)),
      title: _ctx.editDlg?'修改广告位设置':'添加广告位设置',
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDlg = false))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onDlgConfirm
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "form",
          model: _ctx.form,
          rules: _ctx.rules,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "adpKey",
              prop: "adpKey"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.adpKey,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.adpKey) = $event)),
                  disabled: _ctx.editDlg,
                  placeholder: "广告位唯一区分key"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "广告位名字",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.name) = $event)),
                  placeholder: "方便人为识别的名字"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "adpid",
              prop: "adpid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.adpid,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.adpid) = $event)),
                  placeholder: "uniAD组件adpid"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "显示概率",
              prop: "showRatio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.showRatio,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.showRatio) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  placeholder: "显示广告的概率，百分比分子"
                }, {
                  append: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}